import { getMaintenanceAnnouncement } from '@gearbelt/global';
import { WarningTriangleIcon } from '@gearbelt/ui/icons';

import { MAINTENANCE_WINDOW } from '@/maintenance';
import { useUserStore } from '@/stores/user.store';

import { SiteBanner } from './site-banner';

const BANNER_ID = `scheduled-maintenance:${MAINTENANCE_WINDOW.startIso}`;

export function ScheduledMaintenanceBanner() {
  const userTimezone = useUserStore((state) => state.user?.timezone);

  const announcement = getMaintenanceAnnouncement(new Date(), userTimezone);
  if (!announcement) return null;

  return (
    <SiteBanner id={BANNER_ID} variant="warning" icon={<WarningTriangleIcon size={20} />} dismissible={false}>
      <span className="font-medium">{announcement.lead}</span> {announcement.detail}
    </SiteBanner>
  );
}
